import { RemindPasswordModal } from "modules/authentication/presentation/RemindPasswordModal";

import { useModal } from "components/Modal";

import { LoginModal } from "./LoginModal";
import { LoginButton } from "./LoginButton";
import { IButtonProps } from "components/Button";

interface IProps {
  loginBtnProps?: Omit<IButtonProps, "id">;
}

const Login = ({ loginBtnProps }: IProps) => {
  const {
    isOpen: isLoginModalOpen,
    onOpen: onLoginModalOpen,
    onClose: onLoginModalClose,
  } = useModal();

  const {
    isOpen: isRemindPasswordModalOpen,
    onOpen: onRemindPasswordModalOpen,
    onClose: onRemindPasswordModalModalClose,
  } = useModal();

  return (
    <>
      <LoginModal
        onClose={onLoginModalClose}
        isOpen={isLoginModalOpen}
        openRemindPasswordModal={onRemindPasswordModalOpen}
      />
      <RemindPasswordModal
        isOpen={isRemindPasswordModalOpen}
        onClose={onRemindPasswordModalModalClose}
      />
      <LoginButton
        openLoginModal={onLoginModalOpen}
        id="login-btn"
        {...loginBtnProps}
      />
    </>
  );
};

export { Login };
